import { Alert, Snackbar, Typography } from "@mui/material";
import Slide, { SlideProps } from '@mui/material/Slide';
import { useAppDispatch, useAppSelector } from "app/hooks";
import { selectLotOffer, selectLotOfferImages, setImages } from "features/lotOffer/lotOfferSlice";
import compressImageDataUrl from "functions/compressImage";
import { LotOfferInterface } from "interfaces/LotOfferInterface";
import { useState } from "react";
import LotOfferGrid from "./LotOfferGrid";
import LotOfferImage from "./LotOfferImage";
import styles from "./LotOfferImages.module.css";
const IMAGE_WIDTH = parseInt(process.env.FRONTEND_IMAGE_MAX_WIDTH ?? "1920");
const IMAGE_HEIGHT = parseInt(process.env.FRONTEND_IMAGE_MAX_HEIGHT ?? "1080");
const IMAGE_QUALITY = parseInt(process.env.FRONTEND_IMAGE_JPG_QUALITY ?? "80") / 100; 

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

export default function LotOfferImages() {
  const lotOfferImages = useAppSelector(selectLotOfferImages);
  const lotOfferData = useAppSelector(selectLotOffer) as LotOfferInterface;
  const lotOfferSold = lotOfferData?.status === "sold"
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useAppDispatch()
  const handleFileChange = (event: any) => {
    const file = event.target.files[0]
    compressImageDataUrl(file, IMAGE_WIDTH, IMAGE_HEIGHT, IMAGE_QUALITY).then((data) => {
      dispatch(setImages(data))
    }).catch((error) => {
      setHasError(true);
      setErrorMessage(error.message);
    });
  }

  const handleSnackClose = (): void => {
    setHasError(false);
    setErrorMessage("");
  }

  return (
    <LotOfferGrid>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={hasError}
        autoHideDuration={5000}
        onClose={handleSnackClose}
        message={errorMessage}
        TransitionComponent={SlideTransition}
      >
        <Alert
          onClose={handleSnackClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      <Typography
        fontWeight={"bold"}
        variant="h5"
        sx={{
          mt: 2,
          mb: 0.5,
          color: "#072D26",
        }}
      >
        BILDER
      </Typography>
      {lotOfferImages.map((image, index) => (
        <LotOfferImage key={index} index={index} lotOfferImage={image} />
      ))}

      <div>
        <form>
          <div className="form-group">
            <input
              type="file"
              // disabled={files.length === 500}
              className={styles.multiUpload}
              onChange={handleFileChange}
              accept="image/png, image/jpeg, image/heif, image/jpg, image/heic"
              id="labelPreview"
              disabled={lotOfferSold}
            />
            <div className={styles.imageIcons}>
            </div>
            <label className={styles.imagePreviewLabel} htmlFor="labelPreview">
              + BILD HINZUFÜGEN
            </label>
          </div>
        </form>
      </div>
    </LotOfferGrid>
  );
}
